export const SERVICE_CONFIG: Record<
  string,
  {
    divisor: number;
    label: string;
  }
> = {
  rvm: {
    divisor: 1,
    label: 'billing.rvms',
  },
  ai_call: {
    divisor: 60,
    label: 'billing.minutes',
  },
  voip_call: {
    divisor: 60,
    label: 'billing.minutes',
  },
  email: {
    divisor: 1,
    label: 'billing.emails',
  },
  sms: {
    divisor: 1,
    label: 'billing.sms_count',
  },
};
